import { get } from 'lodash';

export function getLocalizedContent(theme, locale, path) {
    if (locale !== 'en') {
        const localePath = `${path}-${locale}`;
        const localizedValue = get(theme, localePath);

        if (localizedValue) {
            return localizedValue;
        }
    }

    return get(theme, path);
}
